var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotpaired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 24,
    height: 24,
    transform: "translate(4131 3288)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_34",
    "data-name": "Mask Group 34",
    transform: "translate(-4131 -3288)",
    opacity: 0.419,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "link-horizontal-slash-regular",
    d: "M4.391,2.493a5.436,5.436,0,0,1,1-.093H11.4a5.4,5.4,0,0,1,4.151,8.842l4.44,3.48A3.634,3.634,0,0,0,22.2,11.4a3.593,3.593,0,0,0-3.356-3.585l-.3-.023A.9.9,0,1,1,18.66,6l.3.019a5.4,5.4,0,0,1,2.576,9.911l2.115,1.657a.9.9,0,1,1-1.11,1.417L.345,1.608A.9.9,0,1,1,1.455.192ZM6.57,4.2,14.1,10.132A3.439,3.439,0,0,0,15,7.8a3.594,3.594,0,0,0-3.6-3.6ZM12.6,16.8a5.4,5.4,0,0,1-5.4-5.4,5.319,5.319,0,0,1,.334-1.867l1.526,1.2A3.866,3.866,0,0,0,9,11.4,3.594,3.594,0,0,0,12.6,15h1.871l2.287,1.8ZM1.13,4.489,2.544,5.606a3.593,3.593,0,0,0,2.612,5.775l.3.023A.9.9,0,1,1,5.34,13.2l-.3-.019A5.4,5.4,0,0,1,1.13,4.489Z",
    transform: "translate(4131 3290.4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotpaired);
export default __webpack_public_path__ + "static/media/notpaired.94f2a037ce095c3b0477db5c88da1645.svg";
export { ForwardRef as ReactComponent };